import { matchPath } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import { REACT_APP_FRONTEND_URL } from 'env'
import * as Paths from 'paths'

import { getOrigin } from 'utils/location'
import { memoize } from 'lodash'

// The paths won't change during the lifetime of the app, so we can memoize this
const isKnownPath = memoize((path: string) =>
  matchPath(path, {
    path: Object.values(Paths),
    exact: true,
  }),
)

export function useIsCustomPath() {
  const customDomain = getOrigin() !== REACT_APP_FRONTEND_URL

  const location = useLocation()

  const match = isKnownPath(location.pathname)

  return customDomain && !match
}
